import { type GroupData, type IconCardData } from '@af/design-system-docs-ui';

const officeHours = {
	href: 'https://hello.atlassian.net/wiki/spaces/A11Y/pages/940530583/Accessibility+Office+Hours',
	title: 'A11y Office Hours',
	description: 'Book time with our accessibility specialists.',
};

const annotations = {
	href: 'https://hello.atlassian.net/wiki/spaces/DHub/pages/6659589114/Accessibility+annotations',
	title: 'Accessibility annotations',
	description: 'Communicate accessibility requirements to engineers.',
};

const a11yMate = {
	href: 'https://home.atlassian.com/o/2346a038-3c8c-498b-a79b-e7847859868d/chat?cloudId=a436116f-02ce-4520-8fbb-7301462a1674&rovoChatCloudId=a436116f-02ce-4520-8fbb-7301462a1674&rovoChatPathway=chat&rovoChatAgentId=a7f547de-aa39-4d25-9234-65ac13c19acd',
	title: 'A11y Mate',
	description: 'A Rovo agent that answers your accessibility questions.',
};
const AKB = {
	href: 'https://hello.atlassian.net/wiki/spaces/A11YKB/overview?homepageId=2991104530',
	title: 'Accessibility Knowledge Base',
	description: 'Access hundreds of articles on applying a11y at Atlassian.',
};
const requirements = {
	href: 'https://hello.atlassian.net/wiki/spaces/DHub/pages/4461719822/Accessible+design+requirements',
	title: 'Accessible design requirements',
	description: 'Your checklist for creating inclusive experiences.',
};
const contentAssistant = {
	href: 'https://home.atlassian.com/o/2346a038-3c8c-498b-a79b-e7847859868d/chat?rovoChatPathway=chat&rovoChatCloudId=a436116f-02ce-4520-8fbb-7301462a1674&rovoChatAgentId=51c363f3-5896-43f3-be92-528557b6510f&cloudId=a436116f-02ce-4520-8fbb-7301462a1674',
	title: 'Content Assistant',
	description: 'A Rovo agent to help write clear, concise content that follows a11y standards.',
};

export const contactUsCards: GroupData<IconCardData>[] = [
	{
		title: 'Ask a question or book a critique',
		cards: [officeHours, annotations, a11yMate, AKB, requirements, contentAssistant],
	},
];
